import { useState } from "react";
import useSnap from "../../hooks/useSnap";
import { API_URL } from "../../Utils/const";
import { useNavigate, useParams } from "react-router-dom";

declare global {
    interface Window {
        ReactNativeWebView?: {
            postMessage: (message: string) => void;
        };
    }
}


function Checkout() {
    const navigate = useNavigate();
    const { params, tokenPath } = useParams();
    const [snapShow, setSnapShow] = useState(false);
    const { snapEmbed } = useSnap();

    const payloadParams = params ? JSON.parse(params) : {};

    const postToReactNative = (userId: string, transactionId: string) => {
        if (window.ReactNativeWebView?.postMessage) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: `triggerPay-${userId}`,
                    payload: {
                        transactionId: transactionId,
                        timestamp: Date.now(),
                    },
                })
            );
        }
    };


    const pay = async () => {
        const response = await fetch(`${API_URL}/api/v1/transaction`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenPath}`,
            },
            body: JSON.stringify(payloadParams),
        }).then((res) => res.json());

        if (response && response.success === true) {
            await localStorage.removeItem("cart");
            setSnapShow(true);

            const transactionId = response.data.id;
            console.log("response?.data==>>", response?.data)

            snapEmbed(response.data.snap_token, "snap-container", {
                onSuccess: function (result: any) {
                    console.log("success", result);
                    postToReactNative(payloadParams.user_id, transactionId);
                    navigate(`/order-status?transaction_id=${transactionId}`);
                    setSnapShow(false);
                },
                onPending: function (result: any) {
                    console.log("pending", result);
                    postToReactNative(payloadParams.user_id, transactionId);
                    navigate(`/order-status?transaction_id=${transactionId}`);
                    setSnapShow(false);
                },
                onClose: function () {
                    postToReactNative(payloadParams.user_id, transactionId);
                    navigate(`/order-status?transaction_id=${transactionId}`);
                    setSnapShow(false);
                },
            });
        } else if (response && response.status === "error") {
            // alert(response.errors.map((msg: any) => msg.msg).join(', '))
        }
    };

    return (
        <>
            {!snapShow && (
                <div className="flex flex-col justify-center items-center min-h-screen bg-white space-y-4">
                    <p className="text-gray-700 text-md text-center mb-5">
                        Silakan klik tombol di bawah untuk menyelesaikan pembayaran Anda.
                    </p>
                    <button
                        onClick={pay}
                        className="px-6 py-2 bg-[#1E5FA9] text-white font-semibold rounded-lg shadow-md hover:bg-[#346ca8] transition duration-300"
                    >
                        Bayar Sekarang
                    </button>
                </div>
            )}
            <div className="flex justify-center items-center min-h-screen bg-white">
                <div id="snap-container"></div>
            </div>
        </>
    );
}

export default Checkout;
